const bundledVersion = process.env.REACT_APP_BUILD_VERSION;

export function appBuildVersion() {
  if (/^[a-f0-9]{7,40}$/.test(bundledVersion || '')) return bundledVersion;
  return typeof window !== 'undefined' ? window.instantTranscriberDiagnostics?.version || 'release_unknown' : 'development';
}

export function withClientVersion(url) {
  if (/[?&]client_version=/.test(url)) return url;
  const version = appBuildVersion();
  // Query metadata works with older CORS configurations during a rolling deploy.
  return /^[a-f0-9]{12,40}$/.test(version || '')
    ? `${url}${url.includes('?') ? '&' : '?'}client_version=${version}` : url;
}
